module.exports = __webpack_public_path__ + "24e004ab/img/ion_calendar-number.3ac5bd07.svg";